export default "__VITE_ASSET__NBjuEVz3__";